import type { ReactNode } from "react";

import { Box, Flex, HStack, IconButton } from "@chakra-ui/react";

import { Icon } from "@shared/ui/chakra/data-display/icon";
import { Typography } from "@shared/ui/chakra/typography/typography";

type Props = {
  actionSlot?: ReactNode;
  showBack?: boolean;
  subTitle?: ReactNode;
  subTitleVariant?: "default" | "phone-verification";
  title?: ReactNode;
  onBack?: () => void;
};

export const Header = ({
  actionSlot,
  showBack,
  subTitle,
  title,
  onBack,
}: Props) => {
  const isBackButtonVisible = showBack ?? Boolean(onBack);

  return (
    <Flex direction="column" gap="4">
      <HStack justifyContent="space-between">
        {isBackButtonVisible && (
          <Box>
            <IconButton
              alignSelf="flex-start"
              rounded="full"
              variant="subtle"
              onClick={onBack}
            >
              <Icon name="ChevronLeft" />
            </IconButton>
          </Box>
        )}
        {actionSlot && <Box>{actionSlot}</Box>}
      </HStack>
      <Box>
        {title && (
          <Typography as="h1" fontWeight="semibold" textStyle="3xl">
            {title}
          </Typography>
        )}
        {typeof subTitle === "string" ? (
          <Typography color="text.fg_subtle" textStyle="md">
            {subTitle}
          </Typography>
        ) : (
          subTitle
        )}
      </Box>
    </Flex>
  );
};
